export default {
	name: 'shellyhtnb',
	friendly_name: 'HT NB',
	family: 'sensor',
	isPM: false,
	is_nb: true,
	dashInfoLabels: 'sensor-ht',
	modes: ['sensor'],
	settings: [{ title: 'not_ready' }],
};
